import type { HttpClient } from '#src/fetching/http/http_client.ts';
import type {
  GetWishlistRequest,
  GetWishlistResponse,
  PerformWishlistActionRequest,
  PerformWishlistActionResponse,
} from '@packages/contracts/wishlist';
import {
  GetWishlistResponseSchema,
  PerformWishlistActionResponseSchema,
} from '@packages/contracts/wishlist';

export interface WishlistClient {
  getOwnWishlist: (request: GetWishlistRequest) => Promise<GetWishlistResponse>;
  performAction: (request: PerformWishlistActionRequest) => Promise<PerformWishlistActionResponse>;
}

export function createWishlistClient(http: HttpClient): WishlistClient {
  return {
    async getOwnWishlist({ groupId, participantId }) {
      const response = await http.get(
        `/wishlist/${encodeURIComponent(groupId)}/${encodeURIComponent(participantId)}`,
      );
      return GetWishlistResponseSchema.parse(response);
    },
    async performAction(request) {
      const response = await http.post('/wishlist', request);
      return PerformWishlistActionResponseSchema.parse(response);
    },
  };
}
